import Component from "@glimmer/component";
import { action } from "@ember/object";
import { tracked } from "@glimmer/tracking";
import { FuseJs } from "../lib/fuse";
import WazeCategoryBox from "./waze-category-box";
import { on } from "@ember/modifier";
import didInsert from "@ember/render-modifiers/modifiers/did-insert";
import dIcon from "discourse/ui-kit/helpers/d-icon";
import { i18n } from "discourse-i18n";

export default class WazeSemiCategoryDialogContent extends Component {
  @tracked query = "";
  observer = null;

  willDestroy() {
    super.willDestroy();
    this.observer?.disconnect();
  }

  get filteredCategories() {
    const categories = this.args.semiCategory.categories || [];

    if (!this.query) {
      return categories;
    }

    const fuse = new FuseJs(categories, {
      keys: ["name"],
      threshold: 0.5,
    });
    return fuse.search(this.query).map((res) => res.item);
  }

  @action
  onQueryChange(event) {
    this.query = event.target.value;
  }

  @action
  onInsert(element) {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.focus();
          this.observer?.disconnect();
        }
      });
    });

    this.observer.observe(element);
  }

  <template>
    <div class="waze-semi-category-dialog-content">
      <wz-text-input
        placeholder={{i18n "waze.semi_categories.list.search_placeholder"}}
        {{on "input" this.onQueryChange}}
        {{didInsert this.onInsert}}
      >
        <span
          slot="leading-icon"
          class="waze-semi-category-dialog-content-search-icon"
        >
          {{dIcon "w-search"}}
        </span>
      </wz-text-input>
      <div class="waze-semi-category-dialog-content-categories">
        <div class="waze-semi-category-dialog-content-categories-grid">
          {{#each this.filteredCategories as |c|}}
            <WazeCategoryBox @category={{c}} />
          {{/each}}
        </div>
      </div>
    </div>
  </template>
}
